import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import InspectionForm from "../Components/InspectionForm";
import { getInspection, updateInspection } from "../Reducers/actions";

const InspectionEditPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getInspection(id));
  }, [dispatch, id]);

  const handleSubmit = (values) => {
    // Extract IDs from objects if needed
    const submitData = {
      ...values,
      company_id: typeof values.company_id === 'object' && values.company_id !== null
        ? values.company_id._id
        : values.company_id,
      template_id: typeof values.template_id === 'object' && values.template_id !== null
        ? values.template_id._id
        : values.template_id,
      inspector_id: typeof values.inspector_id === 'object' && values.inspector_id !== null
        ? values.inspector_id._id
        : values.inspector_id,
    };

    dispatch(updateInspection(id, submitData)).then((result) => {
      if (result.success) {
        alert("Inspectie succesvol bijgewerkt!");
        navigate("/zwembadinspecties/inspecties");
      } else {
        alert("Er is een fout opgetreden bij het bijwerken van de inspectie.");
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3>Inspectie Bewerken</h3>
            </div>
            <div className="card-body">
              <InspectionForm onSubmit={handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspectionEditPage;
